import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Transaction } from "./transaction";
import { File } from "../../common/_types/file";

export class TransactionFile extends Resource {
    public override type = 'transactionFiles';
    

    @prop()
    @required()
    public transactionId!: string;

    @propObject(Transaction)
    public transaction!: Transaction;
 
    @prop()
    public fileId!: string;

    @propObject()
    public file!:File;
}